/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from "@azure/msal-browser";

/**
 * Configuration object to be passed to MSAL instance on creation. 
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md 
 */
export const msalConfig = {
    auth: {
        clientId: "d1df728b-d31b-4c07-bd11-6cd12e8a0186", // This is the ONLY mandatory field that you need to supply.
        authority: "https://login.microsoftonline.com/dafe49bc-5ac3-4310-97b4-3e44a28cbf18", // Defaults to "https://login.microsoftonline.com/common"
        redirectUri: "https://customworkflowuat.exlservice.com/SSOLogin" // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
        // postLogoutRedirectUri: "/", // Indicates the page to navigate after logout.
        // clientCapabilities: ["CP1"] // this lets the resource owner know that this client is capable of handling claims challenge.
    },
    cache: {
        cacheLocation: 'sessionStorage', // Configures cache location. "sessionStorage" is more secure, but "sessionStorage" gives you SSO between tabs.
        storeAuthStateInCookie: true, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit: 
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */
export const loginRequest = {
    scopes: ['api://c6d6c678-8116-46eb-b41c-ca5d5691486b/access_as_user']
};

// export const loginRequest = { 
//     scopes: [ "openid", "profile", "User.Read" ], 
//     extraScopesToConsent: [ "api://c6d6c678-8116-46eb-b41c-ca5d5691486b/access_as_user"] 
// };

// export const protectedResources = { 
//     todoListApi: { endpoint: "http://localhost:5000/hello", 
//     scopes: ["https://your-tenant-name.onmicrosoft.com/tasks-api/tasks.read"], 
// }, 
// }
// export const protectedResources = {
//     apiTodoList: {
//         endpoint: 'api://c6d6c678-8116-46eb-b41c-ca5d5691486b/access_as_user',
//         scopes: []
//     },
// };

// export const loginRequest = {
//     scopes: [...protectedResources.apiTodoList.scopes.read, ...protectedResources.apiTodoList.scopes.write],
// };